/** Canonical dashboard paths for organized tours (LDS OrganizedTour). */

export const ORG_TOUR_DASHBOARD_BASE = "/p/dashboard/organized-tours";
/** Canonical v2 search shell (module `organizedTours`). */
export const ORG_TOUR_SEARCH_PATH = `${ORG_TOUR_DASHBOARD_BASE}/search`;
export const ORG_TOUR_RESULTS_PATH = `${ORG_TOUR_DASHBOARD_BASE}/results`;

/** @deprecated — redirect target only */
export const ORG_TOUR_LEGACY_RESULTS_PATH = "/p/dashboard/tour/results";

export const ORG_TOUR_LEGACY_PUBLIC_PROFILE = "tour/profile";

export function encodeOrganizedTourDealId(dealId) {
  return encodeURIComponent(String(dealId ?? "").trim());
}

export function decodeOrganizedTourDealId(encoded) {
  if (encoded == null || encoded === "") return "";
  try {
    return decodeURIComponent(String(encoded));
  } catch {
    return String(encoded);
  }
}

export function orgTourProfileDashboardPath(dealId) {
  const id = encodeOrganizedTourDealId(dealId);
  if (!id) return ORG_TOUR_RESULTS_PATH;
  return `${ORG_TOUR_DASHBOARD_BASE}/profile/${id}`;
}

export function isOrganizedTourResultsPath(pathname) {
  const p = String(pathname || "");
  return (
    p.includes("/organized-tours/results") || p.includes("/tour/results")
  );
}

export function isOrganizedTourDashboardProfilePath(pathname) {
  return String(pathname || "").includes("/organized-tours/profile/");
}

export function isOrganizedTourLegacyPublicProfilePath(pathname) {
  const p = String(pathname || "");
  return p === "/tour/profile" || p.startsWith("/tour/profile/");
}

export function logOrgTourRouteResultsNavigate(from, to) {
  if (!import.meta.env?.DEV) return;
  console.log("[ORG_TOUR_ROUTE_RESULTS_NAVIGATE]", { from, to });
}

export function logOrgTourRouteProfileNavigate(from, to, dealId) {
  if (!import.meta.env?.DEV) return;
  console.log("[ORG_TOUR_ROUTE_PROFILE_NAVIGATE]", {
    from,
    to,
    dealId: dealId != null ? String(dealId) : null,
  });
}

export function logOrgTourRouteParamDealId(dealId, source) {
  if (!import.meta.env?.DEV) return;
  console.log("[ORG_TOUR_ROUTE_PARAM_DEAL_ID]", {
    dealId: dealId != null ? String(dealId) : null,
    source,
  });
}

export function logOrgTourRouteLegacyRedirect(from, to, kind) {
  if (!import.meta.env?.DEV) return;
  console.log("[ORG_TOUR_ROUTE_LEGACY_REDIRECT]", { from, to, kind });
}

export function logOrgTourProfileDirectLoad(dealId, source, found) {
  if (!import.meta.env?.DEV) return;
  console.log("[ORG_TOUR_PROFILE_DIRECT_LOAD]", {
    dealId: dealId != null ? String(dealId) : null,
    source,
    found,
  });
}

export const ORG_TOUR_DEAL_SNAPSHOT_KEY_PREFIX = "orgTourDealSnapshot:";

export function orgTourDealSnapshotStorageKey(dealId) {
  return `${ORG_TOUR_DEAL_SNAPSHOT_KEY_PREFIX}${String(dealId ?? "").trim()}`;
}
